import { difference } from 'lodash';
const CLUBMED = 'CLUBMED';
const PARTNERS = 'PARTNERS';
const FOSUN_PARTNERS = 'FOSUN_PARTNERS';
const FORYOUCLUB = 'FORYOUCLUB';
export function onCheckboxChange(
  checkbox: {
    name: string;
    checked: boolean;
  },
  setFieldValue: (arg0: string, arg1: boolean) => void,
) {
  const fields = {
    [CLUBMED]: {
      checked: [CLUBMED],
      unchecked: [CLUBMED, PARTNERS],
    },
    [PARTNERS]: {
      checked: [CLUBMED, PARTNERS],
      unchecked: [PARTNERS],
    },
    [FOSUN_PARTNERS]: {
      checked: [FOSUN_PARTNERS],
      unchecked: [FOSUN_PARTNERS],
    },
    [FORYOUCLUB]: {
      checked: [FORYOUCLUB],
      unchecked: [FORYOUCLUB],
    },
  };

  if (checkbox.checked) {
    difference(fields[checkbox.name].checked, [checkbox.name]).map((id) => setFieldValue(id, true));
  } else {
    difference(fields[checkbox.name].unchecked, [checkbox.name]).map((id) =>
      setFieldValue(id, false),
    );
  }
}
